import React, { Fragment, useState } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import {
  DatePicker,
} from 'antd';
import dayjs from 'dayjs';
import { dateRangePresets } from '../../apis/constants';
import './style.scss';

const { RangePicker } = DatePicker;
const dateFormat = 'DD-MM-YYYY';

/**
 *
 */
function H3DateSelector({
  startDate, endDate,
  onDateChange, disabled, innerfilter, customStyle, onDateChangeWithDateRangeType,
}) {

  const [rangeData, setRangeData] = useState([]);
  const timePeriods = [
    {
      label: 'Today',
      value: [dayjs(dayjs().utc().subtract(0, 'days').startOf('day')
        .valueOf()),
      dayjs(dayjs().utc().subtract(1, 'days').endOf('day')
        .valueOf())],
    },
    {
      label: 'Yesterday',
      value: [dayjs(dayjs().utc().subtract(1, 'days').startOf('day')
        .valueOf()),
      dayjs(dayjs().utc().subtract(2, 'days').endOf('day')
        .valueOf())],
    },
    {
      label: 'This Week',
      value: [dayjs(dayjs().utc().subtract(1, 'days').startOf('week')
        .valueOf()),
      dayjs(dayjs().utc().subtract(1, 'days').endOf('week')
        .subtract(1, 'day')
        .valueOf())],
    },
    {
      label: 'This Month',
      value: [dayjs(dayjs().utc().subtract(1, 'days').startOf('month')
        .valueOf()),
      dayjs(dayjs().utc().subtract(1, 'days').endOf('month')
        .subtract(1, 'day')
        .valueOf())],
    },
    {
      label: 'Last Month',
      value: [dayjs(dayjs().utc().subtract(1, 'months').startOf('month')
        .valueOf()),
      dayjs(dayjs().utc().subtract(1, 'months').endOf('month')
        .subtract(1, 'day')
        .valueOf())],
    },
    {
      label: 'This Quarter',
      value: [dayjs(dayjs().utc().quarter(dayjs().utc().quarter()).startOf('quarter')
        .valueOf()),
      dayjs(dayjs().utc().endOf('quarter').subtract(1, 'day')
        .valueOf())],
    },
    {
      label: 'Last Quarter',
      value: [dayjs(dayjs().utc().quarter(dayjs().utc().quarter()).subtract(1, 'quarter')
        .startOf('quarter')
        .valueOf()),
      dayjs(dayjs().utc().quarter(dayjs().utc().quarter()).subtract(1, 'quarter')
        .endOf('quarter')
        .subtract(1, 'day')
        .valueOf())],
    },
    {
      label: 'This Year',
      value: [dayjs(dayjs().utc().startOf('years').valueOf()),
        dayjs(dayjs().utc().endOf('years').subtract(1, 'day')
          .valueOf())],
    },
    {
      label: 'Last Year',
      value: [dayjs(dayjs().utc().subtract(1, 'years').startOf('years')
        .valueOf()),
      dayjs(dayjs().utc().subtract(1, 'years').endOf('years')
        .subtract(1, 'day')
        .valueOf())],
    },
  ];

  const findPresetLabel = (selectedDates) => {
    if (!selectedDates || selectedDates.length !== 2) return null;

    const [selectedStart, selectedEnd] = selectedDates;

    for (const period of timePeriods) {
      const [presetStart, presetEnd] = period.value;
      if (
        selectedStart.isSame(presetStart, 'day')
        && selectedEnd.isSame(presetEnd, 'day')
      ) {
        return period.label;
      }
    }

    return null;
  };
  return (
    <Fragment>

      <div className="custom-time-selector__wrapper">
        <div className={!innerfilter && 'custom-time-selector__date-selector'}>
          <RangePicker
            style={(innerfilter && { width: '100%' }) || customStyle}
            disabled={disabled}
            format={dateFormat}
            className="date__selector"
            value={[
              startDate ? dayjs(dayjs(startDate).format(dateFormat), dateFormat) : null,
              endDate ? dayjs(dayjs(endDate).format(dateFormat), dateFormat) : null]}
            onChange={(dates) => {
              if (dates && dates.length === 2) {
                const [start, end] = dates;
                const adjustedStart = start.startOf('day'); // Set to 12:00 AM
                const adjustedEnd = end.endOf('day'); // Set to 11:59 PM

                const presetSelected = findPresetLabel([adjustedStart, adjustedEnd]);

                if (onDateChange) onDateChange([adjustedStart, adjustedEnd]);
                if (onDateChangeWithDateRangeType) onDateChangeWithDateRangeType({ date: [adjustedStart, adjustedEnd], dateRangeType: presetSelected || dateRangePresets.CUSTOM });
              } else {
                if (onDateChange) onDateChange(dates);
                if (onDateChangeWithDateRangeType) onDateChangeWithDateRangeType({ date: dates, dateRangeType: dateRangePresets.CUSTOM });
              }
            }}
            placement="bottom"
            presets={timePeriods}
            onCalendarChange={(dates, dateStrings, info) => {
            }}
          />
        </div>
      </div>
    </Fragment>
  );
}

const mapStateToProps = () => ({

});

const mapDispatchToProps = () => ({

});
H3DateSelector.propTypes = {
  startDate: PropTypes.func,
  endDate: PropTypes.func,
  onDateChange: PropTypes.func,
  innerfilter: PropTypes.bool,
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(H3DateSelector));
